import { convertQueryStringToObject, queryString } from './';

export default function removeQueryFromUrl(url = '', params) {
    let finalQuery = {};
    const pathAndQuery = url.split('?');
    if (pathAndQuery.length > 1) {
        finalQuery = convertQueryStringToObject(pathAndQuery[1]);
    }

    params.split(',').forEach((param) => {
        if (finalQuery[param]) {
            delete finalQuery[param];
        }
    });
    return `${pathAndQuery[0]}${queryString(finalQuery)}`;
};



// WEBPACK FOOTER //
// ./app/lib/format/removeQueryFromUrl.js